import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "c-picture--default",
    "data-css": "c-picture"
};
const _hoisted_2 = ["src"];
import { useConfig } from "../features";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NewsListItemImageDefault',
    setup(__props) {
        const { frontendPath } = useConfig();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("picture", _hoisted_1, [
                _createElementVNode("img", {
                    class: "picture__image",
                    src: `${_unref(frontendPath)}/img/Newsroom_green_LMU.svg`,
                    alt: "LMU-Logo",
                    "data-sizes": "auto"
                }, null, 8 /* PROPS */, _hoisted_2)
            ]));
        };
    }
});
